(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Language', Language);

    /* @ngInject */
    function Language ($resource) {
        var resourceUrl =  'api/system/languages/:id';

        return $resource(resourceUrl, {id:'@id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
